import { useState, useRef, useEffect } from 'react'
import { ChevronDown, FileText, Mail, ListChecks } from 'lucide-react'

const ITEMS = [
  { id: 'cre',             icon: FileText,   title: "CRE — Compte-rendu d'entretien", desc: 'Version compliance, traces devoir de conseil' },
  { id: 'client_summary',  icon: Mail,       title: 'Synthèse client',                desc: 'PDF brandé, ton client-facing' },
  { id: 'internal_notes',  icon: ListChecks, title: 'Notes internes & actions',       desc: 'To-do list pour le suivi en CRM' },
]

export default function ExportDropdown({ onExport, disabled }) {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    if (!open) return
    const off = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false) }
    document.addEventListener('mousedown', off)
    return () => document.removeEventListener('mousedown', off)
  }, [open])

  return (
    <div ref={ref} className="relative">
      <button
        disabled={disabled}
        onClick={() => setOpen(!open)}
        className="inline-flex items-center gap-2 rounded-lg bg-ink px-4 py-2 text-[13px] font-medium text-white disabled:opacity-50"
      >
        Exporter <ChevronDown size={13} strokeWidth={2.2} />
      </button>
      {open && (
        <div className="absolute right-0 top-[calc(100%+6px)] z-20 w-[min(18rem,calc(100vw-2rem))] rounded-xl border border-line bg-white p-1.5 shadow-[0_12px_32px_rgba(13,13,13,.08)]">
          {ITEMS.map(({ id, icon: Icon, title, desc }) => (
            <button
              key={id}
              onClick={() => { setOpen(false); onExport(id) }}
              className="flex w-full items-start gap-2.5 rounded-md px-3 py-2.5 text-left hover:bg-bg"
            >
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-line/60 text-fiscal-fg"><Icon size={15} strokeWidth={1.6} /></span>
              <span>
                <span className="block text-[13px] font-semibold">{title}</span>
                <span className="block text-[11.5px] text-muted">{desc}</span>
              </span>
              <span className="ml-auto self-center rounded-full bg-actif-bg px-1.5 py-[2px] text-[9.5px] font-medium text-actif-fg">Prêt</span>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
